import { createCrudActions } from '../utils/crudGenerator';

const formatMachines = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchMachines,
    create: createMachine,
    update: updateMachine,
    delete: deleteMachines
} = createCrudActions('MACHINE', "Maquina", formatMachines);